import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        display: 'flex'
    },
    label: {
        display: 'flex',
        flexGrow: 1,
        margin: 'auto'
    },
    permission: {
        minWidth: '6rem',
        textAlign: 'center'
    },
    permissionLabel: {
        whiteSpace: 'break-spaces',
        maxWidth: 100,
    }
}));

const PermissionHeaderItem = ({
    availablePermissions
}: any) => {
    const classes = useStyles();
    const { t } = useTranslation();

       const label = <div className={classes.root}>
                <div className={classes.label}></div>
            {
                               availablePermissions.map((ap: any) => <div
                    className={classes.permission}
                    key={ap.toString()}
                >
                                        <div className={classes.permissionLabel}>
                {t(`Admin.Type.${ap}`)}</div>
            </div>)
            }
    </div>

    return  label;
}

export default PermissionHeaderItem;
